// extracted by css-extract-rspack-plugin
var _1 = "wMpKBHr59kt55QmP";
var _2 = "wMpKBHr59kt55QmP";
var _3 = "vklqZRZ_h4MtJ2tQ";
var _4 = "vklqZRZ_h4MtJ2tQ";
var _5 = "f9PHTEqxdecODlGI";
var _6 = "f9PHTEqxdecODlGI";
var _7 = "TnytVWjBD_UZ7A9h";
var _8 = "TnytVWjBD_UZ7A9h";
var _9 = "Xsbeur8yssmiXkI0";
var _a = "w1PnAqCnE1sUQ8f7";
var _b = "cXYFyulwod8itlmC";
var _c = "Xsbeur8yssmiXkI0";
var _d = "w1PnAqCnE1sUQ8f7";
var _e = "cXYFyulwod8itlmC";
var _f = "ak5O9t9vZYDn9RDT";
var _10 = "JVcIXxq7uoSfBrrG";
var _11 = "ak5O9t9vZYDn9RDT";
var _12 = "JVcIXxq7uoSfBrrG";
var _13 = "L0snyZkwOMcPJMlb";
var _14 = "L0snyZkwOMcPJMlb";
var _15 = "_HPDj3PgkgEF15jR";
var _16 = "_HPDj3PgkgEF15jR";
var _17 = "h8th1KrQMuM4p10C";
var _18 = "h8th1KrQMuM4p10C";
var _19 = "U4nWm0PF6KAlJyae";
var _1a = "YXhG3zrwufAaybvf";
var _1b = "Ni3Dz_2ahE86LjkQ";
var _1c = "TJbypcN9HYkoroM9";
var _1d = "P1SMiQZgyECbLL7A";
var _1e = "wHbq6KeRvcoDd6Uu";
var _1f = "MK0uYzPs0OEb3QoF";
var _20 = "W1d5qs_i1lAnMMG0";
var _21 = "D1a7xGmgn7IMaKkK";
var _22 = "iRoBHxnyS4OKf7bl";
var _23 = "FwiMJ0MeFjk97vTT";
var _24 = "xvuK8g2uklorqaxe";
var _25 = "V2pmZq1ucp4x42MF";
var _26 = "Rq6jTTy8ckg9gowa";
var _27 = "U4nWm0PF6KAlJyae";
var _28 = "YXhG3zrwufAaybvf";
var _29 = "Ni3Dz_2ahE86LjkQ";
var _2a = "TJbypcN9HYkoroM9";
var _2b = "P1SMiQZgyECbLL7A";
var _2c = "wHbq6KeRvcoDd6Uu";
var _2d = "MK0uYzPs0OEb3QoF";
var _2e = "W1d5qs_i1lAnMMG0";
var _2f = "D1a7xGmgn7IMaKkK";
var _30 = "iRoBHxnyS4OKf7bl";
var _31 = "FwiMJ0MeFjk97vTT";
var _32 = "xvuK8g2uklorqaxe";
var _33 = "V2pmZq1ucp4x42MF";
var _34 = "Rq6jTTy8ckg9gowa";
export { _1 as "country-placeholder", _2 as "countryPlaceholder", _3 as "double-player", _4 as "doublePlayer", _5 as "full-card", _6 as "fullCard", _7 as "multiple-player", _8 as "multiplePlayer", _9 as "pk-carousel", _a as "pk-carousel--container__wrapper", _b as "pk-carousel--slide", _c as "pkCarousel", _d as "pkCarouselContainerWrapper", _e as "pkCarouselSlide", _f as "player-1", _10 as "player-2", _11 as "player1", _12 as "player2", _13 as "sc-pk-carousel-s", _14 as "scPkCarouselS", _15 as "simple-placeholder", _16 as "simplePlaceholder", _17 as "team-flag", _18 as "teamFlag", _19 as "ts-card--medium", _1a as "ts-card--squared", _1b as "ts-historical-carousel", _1c as "ts-historical-carousel__card", _1d as "ts-historical-carousel__card--competition-logo", _1e as "ts-historical-carousel__card--flag", _1f as "ts-historical-carousel__card--goals", _20 as "ts-historical-carousel__card--player-1", _21 as "ts-historical-carousel__card--player-info", _22 as "ts-historical-carousel__card--player-list", _23 as "ts-historical-carousel__card--player-name", _24 as "ts-historical-carousel__card--season-year", _25 as "ts-rank", _26 as "ts-rank__label", _27 as "tsCardMedium", _28 as "tsCardSquared", _29 as "tsHistoricalCarousel", _2a as "tsHistoricalCarouselCard", _2b as "tsHistoricalCarouselCardCompetitionLogo", _2c as "tsHistoricalCarouselCardFlag", _2d as "tsHistoricalCarouselCardGoals", _2e as "tsHistoricalCarouselCardPlayer1", _2f as "tsHistoricalCarouselCardPlayerInfo", _30 as "tsHistoricalCarouselCardPlayerList", _31 as "tsHistoricalCarouselCardPlayerName", _32 as "tsHistoricalCarouselCardSeasonYear", _33 as "tsRank", _34 as "tsRankLabel" }
